import dotenv from "dotenv";
import urljoin from "url-join";

dotenv.config();

const env = {
  development: process.env.NODE_ENV === "development",
  production: process.env.NODE_ENV === "production",
};

const google = {
  mapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};

const backend = {
  AUTH_URI: process.env.REACT_APP_SERVER_URI,
  HTTP_URI: urljoin(process.env.REACT_APP_SERVER_URI ?? "", "graphql"),
  WS_URI: urljoin(process.env.REACT_APP_WS_URI ?? "", "graphql"),
};

const publicNamespace = process.env.REACT_APP_PUBLIC_NAMESPACE;

const conektaConfig = {
  publicApiKey: process.env.REACT_APP_CONEKTA_PUBLIC_API_KEY,
};

const mercadoLibre = {
  clientId: process.env.REACT_APP_ML_CLIENT_ID,
};

export { env, backend, publicNamespace, google, conektaConfig, mercadoLibre };
